import { render } from "./App.vue?vue&type=template&id=43f8a59e"
const script = {}

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__